import React, { useState, useEffect } from 'react';
import { Loading, Modal, Form, FormGroup, FormLabel, InlineNotification } from '@carbon/react';

import { useDispatch } from 'react-redux';

import { showToast } from 'services/toasts';
import { SelectableGroups } from './Groups';
import { useAssignElementsToGroupsMutation } from '@/redux/new_services/elements';
import { informAboutChangedElements } from '@/redux/new_services/element';

const ChangeGroupsForMultipleElementsModal = ({ elements, hideModal }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [preselectedGroups, setPreSelectedGroups] = useState([]);

  useEffect(() => {
    let all_group_ids = (elements || []).map(element => (element.groups || []).map(group => group.model.ID)).flat();
    let group_ids = [...new Set(all_group_ids)];
    setPreSelectedGroups(group_ids);
  }, [elements, setPreSelectedGroups]);

  const dispatch = useDispatch();
  const [
    assignElementsToGroups,
    {
      isLoading: isSaving,
      error
    }
  ] = useAssignElementsToGroupsMutation();

  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Übernehmen"
      secondaryButtonText="Abbrechen"
      modalHeading="Gruppenzuordnungen anpassen"
      onRequestClose={hideModal}
      className="change-groups-modal"
      onRequestSubmit={async () => {
        setIsLoading(true);

        try {
          // Split the selection into plain media tiles and variant-group
          // tiles. The backend's /api/elements/groups endpoint accepts
          // both: plain `ids` for media (and pair primaries) and
          // `variant_group_ids` for variant groups, which it expands
          // server-side to each group's member media. Without this split
          // a variant-group tile's `model.ID` (= the preview media id)
          // would be the only thing assigned, leaving the rest of the
          // group's members untouched.
          const mediaIds = [];
          const variantGroupIds = [];
          for (const el of elements || []) {
            if (el?._is_variant_group && el._variant_group?.model?.ID) {
              variantGroupIds.push(el._variant_group.model.ID);
            } else if (el?.model?.ID) {
              mediaIds.push(el.model.ID);
            }
          }

          await assignElementsToGroups({
            ids: mediaIds,
            variantGroupIds,
            groups: selectedGroups,
            preSelectedGroups: preselectedGroups,
          }).unwrap();

          for (const id of mediaIds) {
            dispatch(informAboutChangedElements([id]));
          }
          dispatch(showToast({
            kind: 'success',
            title: 'Erfolgreich',
            caption: 'Die Elemente wurden den Gruppen erfolgreich zugeordnet.',
          }));

        } catch(e) {
          console.error('error assigning elements to groups:', e);
          dispatch(
            showToast({
              kind: 'error',
              title: 'Fehler',
              caption: `Beim zuweisen der Gruppen ist ein Fehler aufgetreten. ${e?.data?.msg || e?.message || ''}`,
            })
          );
        }

        setIsLoading(false);
        hideModal();

      }}>
      <Loading active={isLoading || isSaving} withOverlay={true} />
      <Form>
        <FormGroup legendText="Gruppen">

          <SelectableGroups inDialog={true} selection={selectedGroups} preSelected={preselectedGroups} onSelectionChange={(new_selection, new_preselection) => {setSelectedGroups(new_selection); setPreSelectedGroups(new_preselection)}} />
          <br/>
          <InlineNotification
            aria-label="closes notification"
            kind="info"
            hideCloseButton={true}
            statusIconDescription="notification"
            subtitle="Wenn einzelne Elemente bereits Gruppen zugeordnet sind, erscheinen diese Grau hinterlegt. Sie können die Gruppenzuordnung entfernen, diese dann erneut setzen und für allen Elemente auswählen."
            title="Bereits verwendete Gruppen"
          />
        </FormGroup>
      </Form>
    </Modal>
  );
};


export default ChangeGroupsForMultipleElementsModal;
